import { createApi } from '@reduxjs/toolkit/query/react';
import customBaseQuery from '@/lib/customBaseQuery';

const baseUrl = '/api/file-library';

export const fileLibraryApi = createApi({
  reducerPath: 'fileLibraryApi',
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fileLibraryTableList: builder.query<FileLibraryFoldersResponse, FileLibraryFolderParams>({
      query: (params) => ({
        url: `${baseUrl}`,
        params,
      }),
    }),
    fileLibraryEventList: builder.query<FileLibraryEventListResponse[], { eventIds: number[] }>({
      query: (params) => ({
        url: `${baseUrl}/events`,
        params,
      }),
    }),
    fileLibraryDocument: builder.query<Blob, string>({
      query: (fileKey) => ({
        url: `${baseUrl}/document/${fileKey}`,
        responseType: 'arraybuffer',
        responseHandler: (response) => response.blob(),
        headers: {
          Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        },
      }),
    }),
    fileEventReport: builder.query<Blob, number>({
      query: (eventId) => ({
        url: `${baseUrl}/event-report/${eventId}`,
        responseType: 'arraybuffer',
        responseHandler: (response) => response.blob(),
        headers: {
          Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        },
      }),
    }),
  }),
});

export const {
  useLazyFileEventReportQuery,
  useLazyFileLibraryDocumentQuery,
  useFileLibraryEventListQuery,
  useFileLibraryTableListQuery,
} = fileLibraryApi;
